const apiUrls = require('../../constants/apiUrls');

const orderDetails = {
    key: 'commercialDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.COMMERCIAL_ORDER_DETAIL_URL}?workOrderNumber[]=${request.workOrderNumber}`;
    },
    dependencies: [
        {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'workOrderNumber'
                }
            ]
        }
    ]
};

export default orderDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/commercialDetails.js